import React, { useState } from 'react';
import { MessageSquare, Mail, Users, CheckCircle, MessageCircle, Youtube, Twitter, User, MessageCircle as DiscordIcon } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';
import { contactInfo } from '../data/mock';

const ContactSection = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    battlefieldHours: '',
    experience: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock form submission
    setIsSubmitted(true);
    setTimeout(() => setIsSubmitted(false), 3000);
  };

  return (
    <section id="contact" className="section-spacing bg-secondary-olive">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <Users className="text-primary" size={32} />
            <span className="caption text-primary">{t('contact.subtitle')}</span>
          </div>
          <h2 className="heading-1 text-primary mb-6">
            {t('contact.title')}
          </h2>
          <p className="body-large text-secondary max-w-3xl mx-auto">
            {t('contact.description')}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16">
          {/* Application Form */}


          {/* Contact Info & Requirements */}
          <div className="space-y-8">
            {/* Contact Information */}
            <div className="bg-gray-800 bg-card rounded-lg p-8">
              <h3 className="heading-2 text-primary mb-6">{t('contact.getInTouch')}</h3>
              

              {/* Social Media */}
              <div className="mt-8 pt-6 border-t border-gray-700">
                <h4 className="body-medium text-primary font-semibold mb-4">{t('contact.followJourney')}</h4>
                <div className="flex space-x-4">
                  <button className="flex items-center space-x-2 btn-secondary text-sm" onClick={() => window.open(contactInfo.social.X, '_blank')}>
                    <Twitter size={16} />
                    <span>X.com</span>
                  </button>
                  <button className="flex items-center space-x-2 btn-secondary text-sm" onClick={() => window.open(contactInfo.social.discord, '_blank')}>
                    <DiscordIcon size={16} />
                    <span>Discord</span>
                  </button>
                </div>
              </div>
            </div>

            {/* Requirements */}
            <div className="bg-page border border-gray-600 rounded-lg p-8">
              <h3 className="heading-3 text-primary mb-6">{t('contact.requirements.title')}</h3>
              
              <div className="space-y-4">
                {t('contact.requirements.list').map((requirement, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <CheckCircle className="text-green-400 mt-1 flex-shrink-0" size={20} />
                    <span className="body-medium text-secondary">{requirement}</span>
                  </div>
                ))}
              </div>

              <div className="mt-8 p-4 bg-secondary-olive rounded-lg">
                <div className="flex items-start space-x-3">
                  <MessageCircle className="text-yellow-400 mt-1" size={20} />
                  <div>
                    <div className="body-medium text-primary font-semibold mb-2">{t('contact.proTip.title')}</div>
                    <div className="body-medium text-secondary">
                      {t('contact.proTip.text')}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;